var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog"},[_c('div',{staticClass:"dialog-avatar"}),_c('div',{staticClass:"dialog-content"},[_c('p',{staticClass:"dialog__title"}),_c('p',{staticClass:"dialog__text"})])])
}]

export { render, staticRenderFns }